<template>
  <div class="card mb-0" :class="auctionSeatStyle(auction, seat)">
    <div class="card-body p-1">
      <div class="row d-flex align-items-center">
        <div class="col-5 d-flex align-items-center">
          <small style="min-width: 12px" class="mr-3">{{ seat.number }}</small>
          <div class="d-flex align-items-center small" v-if="!!seat.bidder_id">
            <span>{{ seat.bidder }}</span>
          </div>
          <div
            v-else-if="
              !seat.bidder_id &&
              authenticated &&
              auction.status !== 'Completed' &&
              auction.status !== 'Canceled'
            "
          >
            <form
              method="post"
              :action="'/auctions/' + auction.id + '/seat/' + seat.id"
              class="form-horizontal m-0"
              name="purchase-seat"
              data-title="Confirm Auction Seat Purchase"
              :data-text="`You are purchasing seat #${
                seat.number
              } for ${this.$options.filters.formatNumber(
                seat.tokenPrice
              )} tokens.<br /><br /><div class='alert alert-warning bg-white border-0 mb-0 pb-0' role='alert'>Preset your highest bid below:</div>`"
              data-noicon="true"
              :data-value="
                this.$options.filters.formatDecimalNoGroup(
                  auction.originalPrice / 2
                )
              "
            >
              <input type="hidden" name="_token" :value="getCsrfToken()" />
              <button
                type="submit"
                class="btn btn-md btn-link p-0 text-white small"
              >
                Seat price: {{ seat.tokenPrice | formatNumber }} tokens
              </button>
            </form>
          </div>
          <div
            v-else-if="
              !seat.bidder_id &&
              auction.status !== 'Completed' &&
              auction.status !== 'Canceled'
            "
            class="small"
          >
            Seat price: {{ seat.tokenPrice | formatNumber }} tokens
          </div>
          <div v-else-if="!seat.bidder_id" class="small">
            Seat no longer available
          </div>
        </div>
        <div class="col-4 d-flex flex-row justify-content-between">
          <div
            v-if="
              auction.current_bidder === seat.number && seat.bidder_id == userId
            "
            class="text-center w-100"
          >
            <small
              >Current Price:
              <strong class="text-dark">{{
                auction.current_round_price | formatDollars
              }}</strong></small
            >
            <form
              method="post"
              :action="
                '/auctions/' + auction.id + '/seat/' + seat.id + '/accept'
              "
              class="m-0 d-inline"
            >
              <input type="hidden" name="_token" :value="getCsrfToken()" />
              <button type="submit" class="btn btn-sm m-0 p-0 px-1 btn-info">
                Accept!
              </button>
            </form>
          </div>
          <span
            class="h5 text-bold text-white mb-0 text-center"
            v-if="
              !!auction.winner && auction.winner.auction_seat_id === seat.id
            "
            >WINNER<i class="fas fa-medal"></i
          ></span>
          <div
            v-if="
              !!auction.current_bidder &&
              auction.current_bidder + 1 === seat.number
            "
            class="text-center w-100"
          >
            <small class="text-light"
              >Next Price:
              <strong>{{
                auction.next_seat_bid_floor | formatDollars
              }}</strong></small
            >
          </div>
          <div v-if="auction.current_bidder === seat.number" class="mx-auto">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
        </div>
        <div class="col-3 d-flex flex-row justify-content-between">
          <div
            v-if="
              seat.bidder_id == userId &&
              auction.status !== 'Completed' &&
              auction.status !== 'Canceled'
            "
            class="text-right ml-auto"
          >
            <small>Your Preset price: </small>
            <form
              method="post"
              :action="'/auctions/' + auction.id + '/seat/' + seat.id"
              class="m-0 d-inline"
              name="purchase-seat"
              data-title="Update your preset price"
              :data-text="`Your preset price for seat #${
                seat.number
              } is currently ${this.$options.filters.formatDollars(
                seat.preset_bid_cents
              )}`"
              :data-value="this.$options.filters.formatDecimalNoGroup(seat.preset_bid_cents)"
              data-noicon="true"
            >
              <input type="hidden" name="_token" :value="getCsrfToken()" />
              <input type="hidden" name="_method" value="patch" />
              <button
                type="submit"
                class="btn btn-md btn-link p-0"
                :class="{
                  'text-white': auction.current_bidder !== seat.number,
                  'text-muted': auction.current_bidder === seat.number,
                }"
              >
                {{ seat.preset_bid_cents | formatDollars }}
              </button>
            </form>
          </div>
          <div class="ml-auto" v-else-if="seat.bidder_id == userId">
            <small
              >Your preset price:
              {{ seat.preset_bid_cents | formatDollars }}</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    seat: {
      required: true,
    },
    auction: {
      required: true,
    },
  },
  data: function () {
    return { authenticated: window.authenticated, userId: window.userId };
  },
  methods: {
    auctionStatusText: function (status) {
      if (status === "Completed") {
        return "Auction Ended";
      } else if (status === "InProgress") {
        return "Auction Started";
      } else if (status === "Canceled") {
        return "Auction Canceled";
      } else {
        return "Auction Error";
      }
    },
    auctionSeatStyle: function (auction, seat) {
      if (auction.status === "InProgress") {
        if (auction.current_bidder === seat.number) {
          return "bg-warning";
        }
        /*
        if (seat.number <= auction.current_bidder) {
          return "text-white bg-light-grey";
        }
        */
      }
      if (auction.status === "Completed" && !!auction.winner) {
        if (auction.winner.auction_seat_id === seat.id) {
          return "text-white bg-success";
        }
      }
      return "text-white bg-dark";
    },
    getCsrfToken: function () {
      return document.querySelector('meta[name="csrf-token"]').content;
    },
  },
};
</script>
